<template>
    <div class="loader-holder">
        <span class="far loader fa-spinner fa-spin fa-3x"></span>
    </div>
</template>
<script>
export default {
    name: "loader",
    props: {},
    data: function () {
        return {};
    },
    methods: {},
};
</script>
